var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectsSpaceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2198 26.2451H1.77734",
    stroke: "#5770CB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2198 26.2451H1.77734",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1942 20.7773H1.77734",
    stroke: "#5770CB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1942 20.7773H1.77734",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1942 15.04H1.77734",
    stroke: "#5770CB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1942 15.04H1.77734",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77734 5.02587L1.77734 9.65604C1.77734 10.0822 2.1117 10.4277 2.52415 10.4277L20.4474 10.4277C20.8598 10.4277 21.1942 10.0822 21.1942 9.65604V5.02587C21.1942 4.59968 20.8598 4.25418 20.4474 4.25418L2.52415 4.25418C2.1117 4.25418 1.77734 4.59968 1.77734 5.02587Z",
    stroke: "#5770CB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77734 5.02587L1.77734 9.65604C1.77734 10.0822 2.1117 10.4277 2.52415 10.4277L20.4474 10.4277C20.8598 10.4277 21.1942 10.0822 21.1942 9.65604V5.02587C21.1942 4.59968 20.8598 4.25418 20.4474 4.25418L2.52415 4.25418C2.1117 4.25418 1.77734 4.59968 1.77734 5.02587Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1342 24.7706L26.7422 20.2322L28.9382 17.963C29.0764 17.8184 29.1744 17.6381 29.2221 17.4409C29.2698 17.2437 29.2654 17.0369 29.2093 16.8422C29.1532 16.6474 29.0475 16.4717 28.9032 16.3336C28.7589 16.1954 28.5814 16.0999 28.3892 16.0569L18.2217 13.4587C18.0383 13.412 17.8463 13.4151 17.6643 13.4675C17.4823 13.52 17.3165 13.6201 17.1829 13.7581C17.0493 13.8961 16.9525 14.0675 16.9017 14.2555C16.8509 14.4436 16.848 14.642 16.8931 14.8315L19.4076 25.3379C19.455 25.5329 19.5518 25.7113 19.6879 25.855C19.8241 25.9986 19.9947 26.1023 20.1824 26.1554C20.3701 26.2085 20.568 26.2091 20.756 26.1572C20.944 26.1052 21.1152 26.0026 21.2522 25.8598L23.4482 23.5906L27.8402 28.129L31.1342 24.7706Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1342 24.7706L26.7422 20.2322L28.9382 17.963C29.0764 17.8184 29.1744 17.6381 29.2221 17.4409C29.2698 17.2437 29.2654 17.0369 29.2093 16.8422C29.1532 16.6474 29.0475 16.4717 28.9032 16.3336C28.7589 16.1954 28.5814 16.0999 28.3892 16.0569L18.2217 13.4587C18.0383 13.412 17.8463 13.4151 17.6643 13.4675C17.4823 13.52 17.3165 13.6201 17.1829 13.7581C17.0493 13.8961 16.9525 14.0675 16.9017 14.2555C16.8509 14.4436 16.848 14.642 16.8931 14.8315L19.4076 25.3379C19.455 25.5329 19.5518 25.7113 19.6879 25.855C19.8241 25.9986 19.9947 26.1023 20.1824 26.1554C20.3701 26.2085 20.568 26.2091 20.756 26.1572C20.944 26.1052 21.1152 26.0026 21.2522 25.8598L23.4482 23.5906L27.8402 28.129L31.1342 24.7706Z",
    stroke: "#5770CB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1342 24.7706L26.7422 20.2322L28.9382 17.963C29.0764 17.8184 29.1744 17.6381 29.2221 17.4409C29.2698 17.2437 29.2654 17.0369 29.2093 16.8422C29.1532 16.6474 29.0475 16.4717 28.9032 16.3336C28.7589 16.1954 28.5814 16.0999 28.3892 16.0569L18.2217 13.4587C18.0383 13.412 17.8463 13.4151 17.6643 13.4675C17.4823 13.52 17.3165 13.6201 17.1829 13.7581C17.0493 13.8961 16.9525 14.0675 16.9017 14.2555C16.8509 14.4436 16.848 14.642 16.8931 14.8315L19.4076 25.3379C19.455 25.5329 19.5518 25.7113 19.6879 25.855C19.8241 25.9986 19.9947 26.1023 20.1824 26.1554C20.3701 26.2085 20.568 26.2091 20.756 26.1572C20.944 26.1052 21.1152 26.0026 21.2522 25.8598L23.4482 23.5906L27.8402 28.129L31.1342 24.7706Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsSpaceIcon);
export default __webpack_public_path__ + "static/media/projectsSpaceIcon.601b7eb3.svg";
export { ForwardRef as ReactComponent };